import { useState } from "react";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import { CheckCircle, Warning } from "@mui/icons-material";
import { QualityCheck } from "../erp/manufacturing/Product";
import OdooOperationsService from "../erp/manufacturing/OdooOperationsService";

interface ScrapButtonProps {
	svc: OdooOperationsService;
	qualityCheck: QualityCheck;
	disabled?: boolean;
	onError(error: Error): void;
	onClick(): Promise<void>;
	onDone(scrapRef: string): void;
}

export function ScrapButton(props: ScrapButtonProps) {
	const { svc, qualityCheck, disabled, onError, onClick, onDone } = props;

	const [state, setState] = useState<undefined | "busy" | "success" | "failed">(
		undefined,
	);
	const [scrapRef, setScrapRef] = useState<string>();

	return (
		<Button
			variant="contained"
			color="error"
			fullWidth
			disabled={disabled || state === "busy"}
			onClick={async () => {
				setState("busy");
				try {
					const result: any = await svc.callKw(
						"quality.check",
						"rc_scrap",
						[qualityCheck.id as any],
						{},
					);
					const newScrapRef = result.scrapRef;
					setScrapRef(newScrapRef);
					await onClick();
					onDone(newScrapRef);
					setState("success");
				} catch (error) {
					setState("failed");
					onError(error as Error);
				}
			}}
		>
			{state === "busy" && <CircularProgress size="1em" />}
			{state === "failed" && <Warning />}
			{state === "success" && <CheckCircle />}
			&nbsp;Scrap
			{disabled && qualityCheck.state === "fail" && scrapRef
				? ` (${scrapRef})`
				: null}
		</Button>
	);
}
